function initMainProductMediaGallery() {
  if (!window.jQuery || !window.jQuery.fn.slick) return;

  var $page = jQuery('.main-product-page');
  if (!$page.length) return;

  var $main = $page.find('.media-gallery-wrapper');
  var $layout = $page.find('.media-gallery__layout');
  var $nav = $page.find('.media-gallery-nav');
  var $navList = $page.find('.media-gallery-nav__list');
  var $thumbs = $page.find('.media-gallery-nav__thumb');
  if (!$main.length || $main.hasClass('slick-initialized')) return;

  var breakpoint = 768;
  var resizeTimer;
  var layoutRefreshTimer;

  function setGalleryHeight() {
    if (!$layout.length || window.innerWidth < breakpoint) {
      $layout.css('height', '');
      return;
    }

    var height = Math.round($main.outerHeight());

    if (height > 0) {
      $layout.css('height', height + 'px');
    }
  }

  function updateNavOverflow() {
    if (!$nav.length || !$navList.length || window.innerWidth < breakpoint) {
      $nav.removeClass('is-scrollable is-at-end is-at-start');
      $thumbs.removeClass('is-clipped');
      return;
    }

    var list = $navList.get(0);
    var listRect = list.getBoundingClientRect();
    var hasOverflow = list.scrollHeight > list.clientHeight + 1;
    var atEnd = list.scrollTop + list.clientHeight >= list.scrollHeight - 1;
    var atStart = list.scrollTop <= 1;

    $nav.toggleClass('is-scrollable', hasOverflow);
    $nav.toggleClass('is-at-end', atEnd);
    $nav.toggleClass('is-at-start', atStart);

    $thumbs.removeClass('is-clipped');

    if (!hasOverflow || atEnd) return;

    var clippedThumb = null;

    $thumbs.each(function () {
      var rect = this.getBoundingClientRect();
      var isVisible = rect.top < listRect.bottom && rect.bottom > listRect.top;
      var isClipped = rect.bottom > listRect.bottom + 1;

      if (isVisible && isClipped) {
        clippedThumb = this;
      }
    });

    if (clippedThumb) {
      jQuery(clippedThumb).addClass('is-clipped');
    }
  }

  function refreshGalleryLayoutNow() {
    setGalleryHeight();
    updateNavOverflow();
  }

  function refreshGalleryLayout() {
    clearTimeout(layoutRefreshTimer);
    layoutRefreshTimer = setTimeout(refreshGalleryLayoutNow, 50);
  }

  function enableZoom(el) {
    if (!el.length || !jQuery.fn.zoom) return;

    var zoomUrl = el.data('zoom');
    if (!zoomUrl) return;

    el.zoom({
      url: zoomUrl,
      on: 'click',
      touch: true,
      onZoomIn: function () {
        jQuery(this).toggleClass('active');
        $main.slick('slickSetOption', 'swipe', false);
      },
      onZoomOut: function () {
        jQuery(this).toggleClass('active');
        $main.slick('slickSetOption', 'swipe', true);
      },
    });
  }

  function setActiveThumb(index, shouldScroll) {
    $thumbs
      .removeClass('is-active')
      .attr('aria-current', null)
      .eq(index)
      .addClass('is-active')
      .attr('aria-current', 'true');

    if (shouldScroll === false || !$navList.length || window.innerWidth < breakpoint) return;

    var thumb = $thumbs.get(index);
    if (thumb) {
      thumb.scrollIntoView({ block: 'nearest', behavior: 'auto' });
    }
  }

  $main.on('init afterChange', function (event, slick, currentSlide) {
    var index = typeof currentSlide === 'number' ? currentSlide : 0;
    var i = index + 1;

    $page.find('.media-gallery .paging-info .count').text(i + '/' + slick.slideCount);
    $page.find('.media-gallery .paging-info .count').attr('data-count', i);

    $thumbs
      .removeClass('is-active')
      .attr('aria-current', null)
      .eq(index)
      .addClass('is-active')
      .attr('aria-current', 'true');

    requestAnimationFrame(function () {
      var thumb = $thumbs.get(index);

      if (thumb && window.innerWidth >= breakpoint && $navList.length) {
        thumb.scrollIntoView({ block: 'nearest', behavior: 'auto' });
      }

      if ($main.find('.slick-current .js-zoom-enabled .zoomImg').length === 0) {
        enableZoom($main.find('.slick-current .js-zoom-enabled'));
      }

      updateNavOverflow();
    });
  });

  $main.on('lazyLoaded', function () {
    refreshGalleryLayout();

    if (window.innerWidth < breakpoint) {
      $main.slick('setPosition');
    }
  });

  $main.slick({
    lazyLoad: 'ondemand',
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: breakpoint,
        settings: {
          arrows: false,
          fade: false,
          adaptiveHeight: true,
        },
      },
    ],
  });

  function goToThumbSlide(index) {
    if (window.innerWidth < breakpoint) return;

    var targetIndex = parseInt(index, 10);
    if (isNaN(targetIndex)) return;

    setActiveThumb(targetIndex, false);

    if ($main.slick('slickCurrentSlide') === targetIndex) return;

    $main.slick('slickGoTo', targetIndex);
  }

  $thumbs.on('mouseenter.mainProductGallery focus.mainProductGallery', function () {
    goToThumbSlide(jQuery(this).data('slide-index'));
  });

  $navList.on('scroll', updateNavOverflow);

  if ($page.find('.product-form__variants').length) {
    var imageID = $page.find('.product-form__variants option:selected').attr('data-image-id');

    if (imageID) {
      var slideIndex = $main.find('[data-image-id="' + imageID + '"]').closest('.slick-slide').attr('data-slick-index');

      if (slideIndex) {
        $main.slick('slickGoTo', slideIndex, true);
      }
    }
  }

  setTimeout(function () {
    $page.find('.media-gallery .tap-message').fadeOut(1500);
  }, 12000);

  jQuery(window).on('resize.mainProductGallery load.mainProductGallery', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(refreshGalleryLayout, 150);
  });

  $main.on('init', function () {
    refreshGalleryLayoutNow();
  });

  refreshGalleryLayoutNow();

  if (window.ResizeObserver && $main.length) {
    var galleryLayoutObserver = new ResizeObserver(function () {
      refreshGalleryLayout();
    });

    galleryLayoutObserver.observe($main.get(0));
  }
}

function initMainProductMediaGalleryWhenReady() {
  if (!window.jQuery || !window.jQuery.fn.slick) {
    setTimeout(initMainProductMediaGalleryWhenReady, 50);
    return;
  }

  initMainProductMediaGallery();
}

function initWhatsInTheBundleCarousels() {
  if (!window.jQuery || !window.jQuery.fn.slick) return;

  jQuery('.js-whats-in-the-bundle').each(function () {
    var $root = jQuery(this);
    var $carousel = $root.find('.js-whats-in-the-bundle-carousel');

    if (!$carousel.length || $carousel.hasClass('slick-initialized')) return;

    var navInteraction = false;
    var hasInitialized = false;
    var sectionTitle =
      $root.find('.product__whats-in-the-bundle-heading').text().trim() || "What's in this bundle";

    $root
      .find('.js-whats-in-the-bundle-prev, .js-whats-in-the-bundle-next')
      .on('click.whatsInTheBundleTrack', function () {
        navInteraction = true;
      });

    $carousel.on('afterChange.whatsInTheBundleTrack', function (event, slick, currentSlide) {
      if (!hasInitialized) {
        hasInitialized = true;
        return;
      }

      if (navInteraction) {
        navInteraction = false;
        return;
      }

      if (typeof pushSectionTrackingEvent !== 'function') return;

      pushSectionTrackingEvent('Whats Included Carousel Swipe', sectionTitle, {
        subtitle: 'Slide ' + ((currentSlide || 0) + 1),
        linkPath: window.location.pathname,
      });
    });

    //Slick doesn't reset swipeLength on swipeStart, so a stale swipe can swallow the next tap.
    $carousel.on('mousedown.whatsInTheBundle touchstart.whatsInTheBundle', function () {
      var slick = $carousel.slick('getSlick');
      if (slick && slick.touchObject) slick.touchObject.swipeLength = 0;
    });

    $carousel.slick({
      slide: '.js-whats-in-the-bundle-slide',
      arrows: true,
      prevArrow: $root.find('.js-whats-in-the-bundle-prev'),
      nextArrow: $root.find('.js-whats-in-the-bundle-next'),
      infinite: false,
      slidesToScroll: 1,
      swipeToSlide: true,
      centerMode: false,
      edgeFriction: 1,
      mobileFirst: true,
      slidesToShow: 2.7,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3.7,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 1279,
          settings: {
            slidesToShow: 5,
          },
        },
      ],
    });
  });
}

function initWhatsInTheBundleCarouselsWhenReady() {
  if (!window.jQuery || !window.jQuery.fn.slick) {
    setTimeout(initWhatsInTheBundleCarouselsWhenReady, 50);
    return;
  }

  initWhatsInTheBundleCarousels();
}

function initProductAccordion() {
  if (!window.jQuery) return;

  jQuery('.js-product-accordion').each(function () {
    var $accordion = jQuery(this);

    if ($accordion.data('productAccordionInit')) return;
    $accordion.data('productAccordionInit', true);

    var $firstItem = $accordion.find('.js-product-accordion-item').first();
    if ($firstItem.length) {
      var $firstTrigger = $firstItem.find('.js-product-accordion-trigger');
      var $firstPanel = jQuery('#' + $firstTrigger.attr('aria-controls'));

      $firstItem.addClass('is-open');
      $firstTrigger.attr('aria-expanded', 'true');
      $firstPanel.attr('aria-hidden', 'false');
    }

    $accordion.on('click.productAccordion', '.js-product-accordion-trigger', function () {
      var $trigger = jQuery(this);
      var $item = $trigger.closest('.js-product-accordion-item');
      var panelId = $trigger.attr('aria-controls');
      var $panel = jQuery('#' + panelId);
      var isOpen = $item.hasClass('is-open');

      $item.toggleClass('is-open', !isOpen);
      $trigger.attr('aria-expanded', !isOpen ? 'true' : 'false');
      $panel.attr('aria-hidden', !isOpen ? 'false' : 'true');
    });
  });
}

function initProductAccordionWhenReady() {
  if (!window.jQuery) {
    setTimeout(initProductAccordionWhenReady, 50);
    return;
  }

  initProductAccordion();
}

var whatsInBundleContentCache = {};
var whatsInBundleActiveTrigger = null;
var whatsInBundleCurrentState = { sectionTitle: 'N/A', itemTitle: 'N/A' };

//body.no-scroll resets the scroll to 0, so record it in the capture phase (before
//customDrawer() runs) and apply/restore it when aria-hidden changes.
function initWhatsInBundleScrollLock($drawer) {
  var drawer = $drawer.get(0);
  if (!drawer || !window.MutationObserver) return;

  var scrollY = null;

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-action="open-drawer"][data-drawer-id="whats-in-bundle"]')) {
      scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    }
  }, true);

  new MutationObserver(function () {
    if (scrollY === null) return;

    if (drawer.getAttribute('aria-hidden') === 'false') {
      document.body.style.top = -scrollY + 'px';
    } else {
      //Disable the global html smooth scroll so the restore is instant.
      var html = document.documentElement;
      var scrollBehavior = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      document.body.style.top = '';
      window.scrollTo(0, scrollY);
      html.style.scrollBehavior = scrollBehavior;
      scrollY = null;
    }
  }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
}

function initWhatsInBundleGallery($container) {
  if (!window.jQuery || !window.jQuery.fn.slick) return;

  var $slider = $container.find('.js-whats-in-bundle-gallery');
  if (!$slider.length || $slider.hasClass('slick-initialized')) return;

  var $paging = $container.find('.paging-info .count');

  function enableZoom(el) {
    if (!el.length || !jQuery.fn.zoom) return;

    var zoomUrl = el.data('zoom');
    if (!zoomUrl) return;

    el.zoom({
      url: zoomUrl,
      on: 'click',
      touch: true,
      onZoomIn: function () {
        jQuery(this).toggleClass('active');
        $slider.slick('slickSetOption', 'swipe', false);
      },
      onZoomOut: function () {
        jQuery(this).toggleClass('active');
        $slider.slick('slickSetOption', 'swipe', true);
      },
    });
  }

  $slider.on('init afterChange', function (event, slick, currentSlide) {
    var index = typeof currentSlide === 'number' ? currentSlide : 0;

    $paging.text((index + 1) + '/' + slick.slideCount);
    $paging.attr('data-count', index + 1);

    requestAnimationFrame(function () {
      if ($slider.find('.slick-current .js-zoom-enabled .zoomImg').length === 0) {
        enableZoom($slider.find('.slick-current .js-zoom-enabled'));
      }
    });
  });

  $slider.on('lazyLoaded', function () {
    $slider.slick('setPosition');
  });

  $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    if (currentSlide !== nextSlide) pauseWhatsInBundleMedia(jQuery(slick.$slides[currentSlide]));
  });

  $slider.slick({
    lazyLoad: 'ondemand',
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          fade: false,
          adaptiveHeight: true,
        },
      },
    ],
  });

  initWhatsInBundleVideoArrows($container, $slider);

  //Match main PDP: fade out the zoom hint after 12s. Scoped to this content so swapped-out items are unaffected.
  var $tapMessage = $container.find('.tap-message');
  setTimeout(function () {
    $tapMessage.fadeOut(1500);
  }, 12000);
}

//Nudge arrows above the native video control bar while it's likely showing: paused, hovered (desktop) or recently tapped (touch).
function initWhatsInBundleVideoArrows($container, $slider) {
  var $gallery = $container.find('.mini-pdp__gallery');
  var hideDelay = 3000;
  var hideTimer = null;
  var hovering = false;

  function currentVideo() {
    return $slider.find('.slick-current video').get(0);
  }

  function update(recentInteraction) {
    var video = currentVideo();
    var visible = !!video && (video.paused || hovering || recentInteraction);
    $gallery.toggleClass('is-video-controls-visible', visible);
  }

  function showThenIdle() {
    clearTimeout(hideTimer);
    update(true);
    hideTimer = setTimeout(function () {
      update(false);
    }, hideDelay);
  }

  // Pointer events keep touch taps from leaving the hover state stuck on via emulated mouse events.
  $gallery.on('pointerenter pointermove', function (e) {
    if (e.originalEvent.pointerType !== 'mouse') return;
    hovering = true;
    update(true);
  });

  $gallery.on('pointerleave', function (e) {
    if (e.originalEvent.pointerType !== 'mouse') return;
    hovering = false;
    update(false);
  });

  $gallery.on('pointerdown', function (e) {
    if (e.originalEvent.pointerType !== 'mouse') showThenIdle();
  });

  // Media events don't bubble, so listen in the capture phase.
  $slider.get(0).addEventListener('play', showThenIdle, true);
  $slider.get(0).addEventListener('pause', function () { update(false); }, true);

  $slider.on('afterChange', function () {
    clearTimeout(hideTimer);
    update(false);
  });

  update(false);
}

function collapseWhatsInBundleAccordion($container) {
  var $openItem = $container.find('.js-product-accordion-item.is-open');
  if (!$openItem.length) return;

  $openItem.removeClass('is-open');
  $openItem.find('.js-product-accordion-trigger').attr('aria-expanded', 'false');
  $openItem.find('.js-product-accordion-panel').attr('aria-hidden', 'true');
}

//Stop playing media; resetting the iframe src stops YouTube/Vimeo.
function pauseWhatsInBundleMedia($scope) {
  $scope.find('video').each(function () {
    this.pause();
  });
  $scope.find('.media__video-external iframe').each(function () {
    this.src = this.src;
  });
}

function replaceWhatsInBundleContent($content, html) {
  var $oldSlider = $content.find('.js-whats-in-bundle-gallery');
  if ($oldSlider.hasClass('slick-initialized')) {
    $oldSlider.slick('unslick');
  }
  $content.html(html);
}

function setWhatsInBundleContent($content, html) {
  replaceWhatsInBundleContent($content, html);
  initWhatsInBundleGallery($content);
  initProductAccordion();
  collapseWhatsInBundleAccordion($content);
}

//One shared request per handle; failures are removed so they can retry.
function fetchWhatsInBundleContent(handle) {
  if (!whatsInBundleContentCache[handle]) {
    whatsInBundleContentCache[handle] = fetch('/products/' + handle + '?section_id=whats-in-bundle-item')
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to load bundle item');
        return response.text();
      })
      .catch(function (error) {
        delete whatsInBundleContentCache[handle];
        throw error;
      });
  }

  return whatsInBundleContentCache[handle];
}

function loadWhatsInBundleContent(handle, $content) {
  $content.data('whatsInBundleHandle', handle);
  replaceWhatsInBundleContent($content, '<div class="mini-pdp__loading">Loading&hellip;</div>');

  //Ignore stale responses.
  function isCurrent() {
    return $content.data('whatsInBundleHandle') === handle;
  }

  fetchWhatsInBundleContent(handle)
    .then(function (html) {
      if (isCurrent()) setWhatsInBundleContent($content, html);
    })
    .catch(function () {
      if (isCurrent()) {
        replaceWhatsInBundleContent($content, '<div class="mini-pdp__error">Sorry, we couldn’t load this item. Please try again.</div>');
      }
    });
}

function initWhatsInBundleDrawer() {
  if (!window.jQuery) return;

  var $drawer = jQuery('#whats-in-bundle');
  if (!$drawer.length || $drawer.data('whatsInBundleInit')) return;
  $drawer.data('whatsInBundleInit', true);

  var $content = $drawer.find('[data-whats-in-bundle-content]');
  var $title = $drawer.find('[data-whats-in-bundle-title]');

  initWhatsInBundleScrollLock($drawer);

  //Prefetch on intent.
  jQuery(document).on('mouseenter pointerdown focusin', '[data-drawer-id="whats-in-bundle"][data-whats-in-bundle-handle]', function () {
    fetchWhatsInBundleContent(jQuery(this).data('whatsInBundleHandle')).catch(function () {});
  });

  jQuery(document).on('click','[data-action="open-drawer"][data-drawer-id="whats-in-bundle"]', function () {
    var $card = jQuery(this);
    var handle = $card.data('whatsInBundleHandle');
    var title = $card.data('whatsInBundleTitle');

    if (!handle) return;

    whatsInBundleActiveTrigger = this;
    whatsInBundleCurrentState.itemTitle = title || 'N/A';
    whatsInBundleCurrentState.sectionTitle = $card
      .closest('.js-whats-in-the-bundle')
      .find('.product__whats-in-the-bundle-heading')
      .text()
      .trim() || "What's in this bundle";

    $title.text(title || '');
    loadWhatsInBundleContent(handle, $content);
    $drawer.get(0).focus({ preventScroll: true });
  });

  //Escape clicks the close button; Tab is trapped (focusables re-queried as content loads async).
  jQuery(document).on('keydown.whatsInBundle', function (e) {
    if ($drawer.attr('aria-hidden') !== 'false') return;

    if (e.key === 'Escape' || e.keyCode === 27) {
      $drawer.find('[data-action="close-drawer"]').first().trigger('click');
      return;
    }

    if (e.key !== 'Tab' && e.keyCode !== 9) return;

    var $focusable = $drawer
      .find('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])')
      .filter(':visible');
    var first = $focusable.get(0);
    var last = $focusable.get($focusable.length - 1);
    var active = document.activeElement;

    if (!first) {
      e.preventDefault();
    } else if (e.shiftKey && (active === first || active === $drawer.get(0) || !$drawer.get(0).contains(active))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (active === last || !$drawer.get(0).contains(active))) {
      e.preventDefault();
      first.focus();
    }
  });

  jQuery(document).on(
    'click',
    '[data-action="close-drawer"][data-drawer-id="whats-in-bundle"], .modal-overlay[data-drawer-id="whats-in-bundle"]',
    function () {
      pauseWhatsInBundleMedia($content);

      if (typeof pushSectionTrackingEvent === 'function') {
        pushSectionTrackingEvent('Whats Included Drawer Close', whatsInBundleCurrentState.sectionTitle, {
          subtitle: whatsInBundleCurrentState.itemTitle,
        });
      }

      if (whatsInBundleActiveTrigger) {
        whatsInBundleActiveTrigger.focus({ preventScroll: true });
        whatsInBundleActiveTrigger = null;
      }
    }
  );
}

function initWhatsInBundleDrawerWhenReady() {
  if (!window.jQuery) {
    setTimeout(initWhatsInBundleDrawerWhenReady, 50);
    return;
  }

  initWhatsInBundleDrawer();
}

document.addEventListener('DOMContentLoaded', function () {
  initMainProductMediaGalleryWhenReady();
  initWhatsInTheBundleCarouselsWhenReady();
  initProductAccordionWhenReady();
  initWhatsInBundleDrawerWhenReady();
});
